import axios from 'axios';
import { toast } from 'react-toastify';
import { store } from './store/store';
import { getTenantSlug } from './store/tenantSlug.slice';
import { getAuthToken, removeAuthToken } from './utils/cookie-helper';

const instance = axios.create({ baseURL: import.meta.env.VITE_BASE_URL });

instance.interceptors.request.use((config) => {
  const token = getAuthToken();
  // Only set Authorization header if token exists
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  config.headers['Access-Control-Allow-Credentials'] = 'true';
  config.headers['Access-Control-Allow-Origin'] = '*';
  config.headers['Accept-Language'] = localStorage.getItem('lang');

  // Add tenant slug to URL if it exists
  const state = store.getState();
  const tenantSlug = getTenantSlug(state);

  // List of endpoints that should NOT have tenant slug prepended
  const excludedEndpoints = [
    '/app/time-zones',
    '/app/timezones',
    '/app/countries',
    '/app/languages',
  ];

  if (tenantSlug && config.url) {
    // Check if this endpoint should be excluded
    const isExcluded = excludedEndpoints.some(endpoint =>
      config.url?.includes(endpoint)
    );

    // Only add tenant slug if URL doesn't already start with it,
    // is not an absolute URL, and is not in the excluded list
    if (!config.url.startsWith('http') &&
        !config.url.startsWith(`/${tenantSlug}/`) &&
        !isExcluded) {
      // Remove leading slash if present
      const cleanUrl = config.url.startsWith('/') ? config.url.slice(1) : config.url;
      config.url = `/${tenantSlug}/${cleanUrl}`;
    }
  }

  return config;
});

//error handling to axios instance and show error message with toast for every poosible error
instance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    switch (error?.response?.status) {
      case 400:
        toast.error(error.response.data.message);
        break;
      case 401:
        toast.error(error.response.data.message);
        removeAuthToken();
        window.location.href = '/';
        break;
      case 404:
        if (!error.config?.url?.includes('payment/myfatoorah/status')) {
          error.response?.data?.message &&
            toast.error(error.response.data.message);
          window.location.href = '/404';
        }
        break;
      case 500:
        toast.error('something went wrong');
        window.location.href = '/error';
        break;
      case 422:
        break;
      case 409:
        break;
      default:
        toast.error(error.response.data.message);
        break;
    }
    return Promise.reject(error);
  }
);

export default instance;
